module.exports = __webpack_public_path__ + "static/img/Man Bags.c60dc77.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Man Bags.jpg
// module id = KFEI
// module chunks = 1